import { PartState } from '../types';
import { straightOnState } from './straight-on';

/** Overlay hand paths — visible portion below the illustration crop (Meet Bizy promo). */
export const PEEKING_HAND_PATHS = {
	left: 'M88 110 L90 118',
	right: 'M218 110 L216 118',
} as const;

/** Full arm paths from body shoulders to paw endpoints (matches PEEKING_HAND_PATHS end points). */
const PEEKING_ARM_PATHS = {
	left: 'M107.22 139L90 118',
	right: 'M201.62 140.17L216 118',
} as const;

/**
 * Peeking pose — straight-on body with arms reaching to the ledge. Pair with
 * `BizyPeekingHands` in cropped layouts so paws below the illustration edge stay visible.
 */
export const peekingState: PartState = {
	...straightOnState,
	arms: [
		{ d: PEEKING_ARM_PATHS.left, side: 'left' },
		{ d: PEEKING_ARM_PATHS.right, side: 'right' },
	],
	armOrder: 'bothFront',
};
